import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { LabBinderPageComponent } from './lab-binder.page.component';
import { getLabCategoryById, getItemsByCategoryId } from 'shared/store/selectors/lab.selector';
import { updateValueOrder, createQuickLabItem } from 'shared/store/actions/lab.values.actions';
import { labSelectValues } from '../../../store/actions/labViewer.actions';
import { INTERNAL_ROUTING } from 'shared/constants';

const mapStateToProps = ({ labViewer, lab, application, lang }, ownProps) => {
  const { id } = ownProps;
  const items = id ? getItemsByCategoryId(lab, { id }) : [];
  const category = id ? getLabCategoryById(lab, { id }) : {};

  return {
    id,
    category,
    items,
    adminMode: application.adminMode,
    lastUpdated: lab.lastUpdated,
    lang: lang.COMPENDIUM_BUTTONS,
    langTooltip: lang.ACTION_BUTTON_TOOLTIPS,
  };
};

const mapDispatchToProps = {
  labSelectValues,
  updateValueOrder,
  createQuickLabItem,
};

const ConnectedLabBinderPage = connect(mapStateToProps, mapDispatchToProps)(LabBinderPageComponent);

export const LabBinderPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get(INTERNAL_ROUTING.QUERY_PARAMS.COMPENDIUM);

  return <ConnectedLabBinderPage id={id} />;
};
